/**
 * Background Jobs — one tabbed screen built on the shared GroupScreen, the same
 * component behind Notifications, Logs and the other RBAC-shaped admin areas.
 *
 *   Background Job Master WHAT should run    (CRUD)
 *   Background Scheduler  WHEN it should run (CRUD)
 *   Background Settings   how the engine is configured, and whether it is alive
 *
 * This screen is now purely CONFIGURATION. The two views that answer "what
 * happened" — the counts/activity dashboard and the run history grid — both live
 * on the Transactional Dashboard screen, under Background Job Dashboard: the
 * overview above, its Records tab holding the same run grid this screen used to
 * carry. One place for every operational dashboard, and run history is not split
 * across two screens.
 *
 * Run history is still gated on its own key (BACKGROUND_JOB_RUN.READ, separate
 * from BACKGROUND_JOB.READ) — that check moved with it, onto the Records tab.
 *
 * GroupScreen hides a tab the user has no permission for. The finer gating —
 * create / update / delete / execute / toggle — lives inside each tab via
 * useJobPermissions, because those keys are deliberately independent:
 *  · EXECUTE is separate from UPDATE, so an on-call operator can re-run a job
 *    without being able to rewrite it.
 *  · TOGGLE is separate again, so pausing a schedule needs neither.
 */
import GroupScreen from '../../components/layout/group-screen';
import { JOB_NAMES } from '../../constants/jobNames';
import JobsTab from './tabs/jobs-tab';
import SchedulesTab from './tabs/schedules-tab';
import SettingsTab from './tabs/settings-tab';

const BackgroundJobsGroup = () => (
  <GroupScreen
    icon="cpu"
    iconBgColor="bg-teal-600"
    title="Background Jobs"
    subtitle="Define what runs, when it runs, and how the engine is configured"
    testId="SCR-BackgroundJobs"
    tabs={[
      { key: 'jobs', header: 'Background Job Master', leftIcon: 'list-checks', jobs: [JOB_NAMES.BACKGROUND_JOB], element: <JobsTab /> },
      // schedules inherit the job's permissions, so they share its job name
      { key: 'schedules', header: 'Background Scheduler', leftIcon: 'clipboard-clock', jobs: [JOB_NAMES.BACKGROUND_JOB], element: <SchedulesTab /> },
      // Last tab: how the engine is configured and whether anything is driving it.
      // Infrastructure rather than day-to-day work — it matters once the tabs
      // before it show something that should have run and did not.
      { key: 'settings', header: 'Background Settings', leftIcon: 'server-cog', jobs: [JOB_NAMES.BACKGROUND_JOB], element: <SettingsTab /> },
    ]}
  />
);

export default BackgroundJobsGroup;
